import React from 'react'
import TestimonialUpdate from '../testimonial_components/testimonial_update'

export default function TestimonialUpdatePage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <TestimonialUpdate />
    </div>
  )
}
